import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.korslovo.category');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-korslovo-category',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.korslovo.category/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageKorslovoCategoryComponent implements OnInit {
    public ru = RU;
    public loading: boolean = true;
    public sections: any[] = [];
    public expanded: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadCategories();
    }

    public async loadCategories() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("categories");
        if (code === 200) {
            this.sections = data || [];
            // 자동 펼치기: 진행 중인 섹션 또는 첫 미완료 섹션
            let foundActive = false;
            for (const sec of this.sections) {
                const hasProgress = sec.completed_lessons > 0 && sec.completed_lessons < sec.total_lessons;
                const isComplete = sec.total_lessons > 0 && sec.completed_lessons >= sec.total_lessons;
                if (hasProgress) {
                    this.expanded[sec.key] = true;
                    foundActive = true;
                } else if (!isComplete && !foundActive) {
                    this.expanded[sec.key] = true;
                    foundActive = true;
                }
            }
            if (!foundActive && this.sections.length > 0) {
                this.expanded[this.sections[0].key] = true;
            }
        }

        this.loading = false;
        await this.service.render();
    }

    public async toggleSection(key: string) {
        this.expanded[key] = !this.expanded[key];
        await this.service.render();
    }

    public goCategory(cat: any) {
        this.service.href(`/category/${cat.id}`);
    }

    public progressPercent(item: any): number {
        const total = item.total_lessons || item.lesson_count || 0;
        const completed = item.completed_lessons || item.completed_count || 0;
        if (total === 0) return 0;
        return Math.round((completed / total) * 100);
    }

    public totalStars(cat: any): number {
        return cat.total_stars || 0;
    }

    public maxStars(cat: any): number {
        return (cat.lesson_count || 0) * 3;
    }

    public isFullyMastered(cat: any): boolean {
        return this.maxStars(cat) > 0 && this.totalStars(cat) >= this.maxStars(cat);
    }

    public isSectionComplete(sec: any): boolean {
        return sec.total_lessons > 0 && sec.completed_lessons >= sec.total_lessons;
    }

    public isSectionFullyMastered(sec: any): boolean {
        return sec.max_stars > 0 && sec.total_stars >= sec.max_stars;
    }

    public badgeBg(cat: any): string {
        if (this.isFullyMastered(cat)) return 'bg-amber-500';
        const p = this.progressPercent(cat);
        if (p >= 100) return 'bg-emerald-700';
        if (p > 0) return 'bg-emerald-500';
        return 'bg-zinc-300';
    }

    public isCompleted(cat: any): boolean {
        return this.progressPercent(cat) >= 100;
    }
}

export default PageKorslovoCategoryComponent;